import React from 'react'
import Portal from '../portal'
import { AppContext } from '../../config/context'
import './index.scss'
import {
    checkUserInfoLocally,
    clearUserInfoLocally,
    i18n,
    setCookie,
    hbsBoolean,
    getImgUrl
} from '../../common/util'
import { OrderLink } from '../../config'
import { getServiceUrl } from '../service'
import ee, { EVENT_USER_LOGOUT, EVENT_LANG_CHANGE, EVENT_USER_INVALID, EVENT_RECYCLE_OVER, EVENT_USER_NOT_BOUND, EVENT_USER_NOT_CERTED } from '../../common/util/event'
import Bag from '../bag'
import Login from '../login'
import Cert from '../cert'
import Logout from '../logout'

class Header extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            showLoginModal: false,
            showLangSlide: false,
            logout: false,
            showOrderOptions: false,
            showBag: false,
            bagParams: {},
            showCertModal: false,
            headerAdvImg: window._inject_app_data_.headerAdvImg
            // showRent: false
        }
    }

    componentDidMount() {
        const ui = checkUserInfoLocally()
        this.context.updateUserInfo(
            ui
                ? {
                    isLogin: 1,
                    ...ui
                }
                : {
                    isLogin: 0
                }
        )
        document.addEventListener('click', () => this.setState({
            showLangSlide: false,
            showOrderOptions: false
        }))
        ee.addListener(EVENT_USER_INVALID, this.closeBag)
        ee.addListener(EVENT_RECYCLE_OVER, this.closeBag)
        ee.addListener(EVENT_USER_NOT_BOUND, this.showLoginModal)
        ee.addListener(EVENT_USER_NOT_CERTED, this.showCertModal)
    }

    showCertModal = () => {
        this.setState({
            showCertModal: true
        })
    }

    closeCertModal = () => {
        this.setState({
            showCertModal: false
        })
    }

    logout = () => {
        this.setState({
            logout: true
        })
        ee.emit(EVENT_USER_LOGOUT)
    }

    logoutCallback = () => {
        clearUserInfoLocally()
        location.href = '/'
    }

    showLoginModal = () => {
        this.setState({
            showLoginModal: true
        })
    }

    closeLoginModal = () => {
        this.setState({
            showLoginModal: false
        })
    }

    showBag = (bagParams = {}) => {
        if (this.context.user.isLogin === 1) {
            return this.setState({
                bagParams,
                showBag: true
            })
        }
        this.showLoginModal()
    }

    closeBag = () => {
        this.setState({
            showBag: false
        })
    }

    expandOrderOptions = e => {
        e.stopPropagation()
        const { showOrderOptions } = this.state
        this.setState({
            showOrderOptions: !showOrderOptions,
            showLangSlide: false
        })
    }

    toggleLangSlide = e => {
        e.stopPropagation()
        const { showLangSlide } = this.state
        this.setState({
            showLangSlide: !showLangSlide,
            showOrderOptions: false
        })
    }

    selectLang = lang => {
        setCookie('_gml', lang)
        this.context.updateUserInfo({
            lang
        })
        ee.emit(EVENT_LANG_CHANGE, lang)
        function primitiveUpdate(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = i18n(node.textContent, lang)
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                let children = node.childNodes
                if (children.length) {
                    for (let i = 0; i < children.length; ++i) {
                        primitiveUpdate(children[i])
                    }
                }
            }
        }
        const collection = document.getElementsByClassName('p-l-w')
        for (let i = 0; i < collection.length; ++i) {
            primitiveUpdate(collection[i])
        }
        document.title = i18n(document.title, lang)
        const metaCt = document.getElementsByTagName('meta')
        for (let i = 0; i < metaCt.length; ++i) {
            let m = metaCt[i]
            if (m.name === 'description' || m.name === 'keywords') {
                m.content = i18n(m.content, lang)
            }
        }
    }

    goToOrder = () => {
        if (this.context.user.isLogin === 1) {
            return window.open(OrderLink)
        }
        this.showLoginModal()
    }

    goToBbOrder = () => {
        this.showBag({ index: 2 })
    }

    goToBag = () => {
        this.showBag({ index: 1 })
    }

    goToService = () => {
        getServiceUrl().then(href => {
            window.open(href)
        })
    }

    render() {
        const { showLangSlide, logout, showLoginModal, showCertModal, showOrderOptions, showBag, bagParams, headerAdvImg } = this.state
        const userInfo = this.context.user
        const lang = userInfo.lang
        return <div className="G-header-content">
            <a target="_self" href="/">
                <i className="G-header-logo"></i>
            </a>
            {
                hbsBoolean(headerAdvImg) && <div className='activity-logo'>
                    <img alt='' className='activity-logo-img' src={getImgUrl(headerAdvImg)} />
                </div>
            }
            <div className="G-header-bar">
                {/* <div className="G-header-bar-item">
                    <i className="icon cart"></i>
                    <span className="text">{i18n('购物车', lang)}</span>
                </div> */}
                <div className="G-header-bar-item" onClick={this.goToService}>
                    <i className="icon service"></i>
                    <span className="text">{i18n('客服', lang)}</span>
                </div>
                <div className="G-header-bar-item order" onClick={this.expandOrderOptions}>
                    <i className="icon order"></i>
                    <span className="text">{i18n('订单', lang)}</span>
                    {
                        showOrderOptions && <div className='header-order-options-wrapper'>
                            <div className='header-order-option' onClick={this.goToOrder}>{i18n('商品订单', lang)}</div>
                            <div className='header-order-option' onClick={this.goToBbOrder}>{i18n('盲盒订单', lang)}</div>
                        </div>
                    }
                </div>
                <div className="G-header-bar-item" onClick={this.goToBag}>
                    <i className="icon bag"></i>
                    <span className="text">{i18n('背包', lang)}</span>
                </div>
                {
                    userInfo.isLogin === 0 && <div className="G-header-bar-item login" onClick={this.showLoginModal}>
                        <i className="icon login"></i>
                        <span className="text">{i18n('登录', lang)}</span>
                    </div>
                }
                {
                    userInfo.isLogin === 1 && <div className="G-header-bar-item logout">
                        <span className="logout" onClick={this.logout}>{i18n('退出', lang)}</span>
                        <a target='_blank' href={OrderLink}>
                            <p className="display-name">{i18n(userInfo.displayName, lang)}</p>
                        </a>
                    </div>
                }
                <div className={showLangSlide ? 'G-header-bar-item lang exp' : 'G-header-bar-item lang'} onClick={this.toggleLangSlide}>
                    <span className="text">{i18n(lang === 'zh_HK' ? '繁体' : '简体', lang)}</span>
                    <i className="triangle"></i>
                    {
                        showLangSlide && <div className='G-header-lang-slide'>
                            <div className='G-header-lang' onClick={() => this.selectLang('zh_CN')}>{i18n('简体', lang)}</div>
                            <div className='G-header-lang' onClick={() => this.selectLang('zh_HK')}>{i18n('繁体', lang)}</div>
                        </div>
                    }
                </div>
            </div>
            {
                showLoginModal && <Login close={this.closeLoginModal}></Login>
            }
            {
                showCertModal && <Cert close={this.closeCertModal} isForce={true}></Cert>
            }
            {
                showBag && <Bag close={this.closeBag} {...bagParams}></Bag>
            }
            {
                logout && <Logout close={this.logoutCallback}></Logout>
            }
        </div>
    }
}

Header.contextType = AppContext

export default Portal(Header, 'G-header-container')